import { connect, MapDispatchToPropsFunction } from 'react-redux'
import {
  FeedFilterTagsPopup,
  FeedFilterTagsPopupStateProps,
  FeedFilterTagsPopupDispatchProps,
  FeedFilterTagsPopupOwnProps,
} from 'components/features/socialFeed/FeedfilterPopup/FeedFilterTagsPopup'
import { State } from 'interfaces/state'
import {
  hidePopupFeedFilterActionCreator,
  registerPopupFeedFilterTimeoutActionCreator,
  selectFeedFilterActionCreator,
  getFollowedTagsActionCreator,
  resetFollowedTagsActionCreator,
} from 'actions/feedActions'
import { peersRelationSelector } from 'selectors/peergroupSelectors'
import { feedDataSelector, feedAppSelector } from 'selectors/feedSelectors'
import { setShownSidebarPaneActionCreator } from 'actions/sidebarActions'


const mapStateToProps = (state: State, _ownProps: FeedFilterTagsPopupOwnProps): FeedFilterTagsPopupStateProps => {
  const { isLoading, errorCode, pagination } = feedDataSelector(state).followedTagsLoading
  const links = pagination.pagination
  const hasMorePeople =
    !links          // no links when no first request
    || !!links.next // was requests & has next page

  return {
    hidePopupTimeoutId: state.app.feed.filterPopup.hideTimeoutId,
    peersRelation: peersRelationSelector(state),
    shouldResetOnUnmount: feedAppSelector(state).shouldResetFollowedTags,

    hasMore: hasMorePeople,
    isLoading: isLoading,
    followedTagNames: pagination.results,
    errorCode: errorCode,
    paginationLinks: links,
  }
}

const mapDispatchToProps: MapDispatchToPropsFunction<
  FeedFilterTagsPopupDispatchProps,
  FeedFilterTagsPopupOwnProps
> = (dispatch, _ownProps) => ({
  onLoadMore: (links) => dispatch(
    getFollowedTagsActionCreator.request({ links }),
  ),
  onResetFollowedTags: () => dispatch(resetFollowedTagsActionCreator()),
  onViewPosts: () => {
    dispatch(selectFeedFilterActionCreator({
      type: 'feedgroup',
      slug: 'followed_tags',
    }))
    dispatch(setShownSidebarPaneActionCreator(null))
  },
  onExplorePosts: (relation) => {
    dispatch(selectFeedFilterActionCreator({
      type: 'peergroup',
      relationId: relation.id,
    }))

    dispatch(setShownSidebarPaneActionCreator(null))
  },
  onHidePopup: () => dispatch(hidePopupFeedFilterActionCreator()),
  onRegisterHideTimeout: (timeoutId) => dispatch(registerPopupFeedFilterTimeoutActionCreator(timeoutId)),
})

export const FeedFilterTagsPopupContainer = connect<
  FeedFilterTagsPopupStateProps,
  FeedFilterTagsPopupDispatchProps,
  FeedFilterTagsPopupOwnProps
>(mapStateToProps, mapDispatchToProps)(FeedFilterTagsPopup)
